// tslint:disable max-line-length triple-equals
import React, { useEffect, useState } from 'react';
import Block from 'lqa-ui/lib/Components/Block';
import Icon from 'lqa-ui/lib/Components/Icon';
import './styles.scss';
import { getItem } from '../../utils/localStorage';
import { Collapse } from 'react-collapse';
import { useNavigate, useLocation } from 'react-router-dom';
import { standard } from './apiCaller';
import { assessments as assessmentApi } from '../Dashboard/apiCaller';
import Tags from 'lqa-ui/lib/Components/Tags';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent/index';
import { StandardPerformaceSelector } from '../../components/commons/StandardPerformanceSelector/standardPerformanceSelector';
import '../../style/main.scss';
import HotelAssessmentSelection from '../../components/commons/Header/HotelAssessmentSelection';
import { translatePerformanceClassificationLabel } from '../../enums/labels/PerformanceClassification';
import { getDepartmentText } from '../../components/Assessment/assessmentHeaderText';
import { useLongPress, LongPressDetectEvents } from 'use-long-press';
import { pressAndHoldMenu } from '../../components/commons/PressAndHold';
import { Portal } from '../../components/commons/Portal';
import { OverlayAudio } from '../../components/commons/AudioPlayer/OverlayAudio';
import { bottomSheet } from '../../components/commons/BottomSheet';
import Skeleton from 'react-loading-skeleton';
import { showErrorMessage } from '../../helpers/showMessage';
import { ANNONYMOUS_NAME } from '../../utils/regex';
import { isUnauthorized } from '../../utils/common';
import { gethasAssessment } from '../../helpers/handleBrandAndHotelData';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { HeaderContainer } from './../../app/common/sharedStyledComponents/GenericStyles.styled';
import {
  AssessmentStandarContainer,
  ContentArea,
} from './AssessmentStandard.styled';

const AssessmentStandard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // let {location} = useHistory();
  const loc: any = { ...location };

  const {
    apiData: l,
    assessmentId,
    tempData,
    categoryId,
    subCategoryId,
    standardType,
    performanceClassificationSummary,
  } = loc.state;

  const [toggle, setToggle] = useState([false]);
  const [toggleTab, settoggleTab] = useState([true]);
  const [toggleSubTab, settoggleSubTab] = useState([true]);
  const [subCat, setSubCat] = useState(l.data[0].subCategory);
  const [Index, setIndex] = useState(1);
  const [std, setStd] = useState<{ stats: any; items: any } | undefined>(
    undefined
  );
  const [assessments, setAssessments] = useState<
    {
      stayStart: string;
      id: number;
    }[]
  >([]);
  const [showMet, setShowMet] = useState({
    met: false,
    notmet: false,
    na: false,
  });
  // const [showNotMet, setShowNotMet] = useState(false);
  const [selectedAssessment, setSelectedAssessment] = useState<string | undefined>(undefined);
  const [selectedCategory, setSelectedCategory] = useState(subCat[0].id);
  const [score, setScore] = useState(subCat[0].score);
  const [audioOverlayOpened, setAudioOverlayOpened] = useState(false);
  const [audio, setAudio] = useState<
    | {
      url: string;
      notes: string;
    }[]
    | []
  >([]);
  const [standards, setStandards] = useState(standardType || 'LQA');
  const [performanceClassification, setPerformaceClassification] = useState(
    performanceClassificationSummary || undefined
  );
  const [selectedHotel, setSelectedHotel] = useState(getItem('selectedHotel'));
  const [selectedClient, setSelectedClient] = useState(
    getItem('selectedClient')
  );
  const [pressHoldData, setPressHoldData] = useState<any>({
    sourceCategoryId: null,
    visit: null,
    standard: [],
  });
  const [openPressAndHold, setOpenPressHold] = useState(false);

  const callback = React.useCallback(() => {
    // alert("Long pressed!");
  }, []);

  const bind = useLongPress(callback, {
    onFinish: (event, meta) => {
      setPressHoldData(meta.context);
      setOpenPressHold(true);
    },
    threshold: 500,
    captureEvent: true,
    cancelOnMovement: false,
    detect: LongPressDetectEvents.BOTH,
  });
  const [open, setOpen] = useState(false);
  const [showCom, setShowCom] = useState(false);
  const [showEq, setShowEq] = useState(false);
  const [eqData, setEqData] = useState<
    | {
      additionalText: string;
      benchmarkTemplateCategoryId: number;
      duplicateCategoryId: number;
      negativeText: string;
      positiveText: string;
      recommendText: string;
      templateCategoryId: number;
      templateEqDescription: string;
      templateEqLabel: string;
      templateEqValue: number;
      visit: number;
      subName: string;
      depCommentary: string;
      time: any;
    }
    | undefined
  >(undefined);
  const [openImage, setOpenImage] = useState(false);
  const [imageData, setImageData] = useState([]);
  const [selectedUrl, setSelectedUrl] = useState('');
  const [notes, setNotes] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [hasAssessment, setHasAssessment] = useState(gethasAssessment());
  useEffect(() => {
    // setSelectedHotel(userData.user.brands[0].hotels[0].id);
    // setItem('selectedHotel', userData.user.brands[0].hotels[0].id);
    // setItem('selectedBrand', userData.user.brands[0].id);
    setSelectedHotel(getItem('selectedHotel'));
  }, []);

  useEffect(() => {
    if (selectedAssessment) {
      standard(
        selectedCategory,
        selectedAssessment,
        3,
        false,
        assessmentId,
        standards,
        performanceClassification
      )
        .then((res) => setStd(res))
        .catch((err) => {
          showErrorMessage('Could not find standard', !isUnauthorized(err));
        });
    }
    // handleTabs(0);
    // handleSubTabs(10);
    const subCatData = l.data.find((o) => o.id === categoryId);
    const selSubCatData = subCatData.subCategory.find(
      (o) => o.id === subCategoryId
    );
    const index = l.data.findIndex((x) => x.id === categoryId);
    const indexSub = subCatData.subCategory.findIndex(
      (x) => x.id === subCategoryId
    );
    handleTabs(index);
    handleSubTabs(parseInt(`${index + 1}${indexSub}`));
    setSubCat(subCatData.subCategory);
    setSelectedCategory(selSubCatData.id);
    setIndex(index + 1);
    setScore(selSubCatData.score);
  }, []);
  useEffect(() => {
    if (selectedAssessment) {
      standard(
        selectedCategory,
        selectedAssessment,
        3,
        false,
        assessmentId,
        standards,
        performanceClassification
      ).then((res) => setStd(res));
    }
  }, [
    selectedCategory,
    selectedAssessment,
    standards,
    performanceClassification,
  ]);
  useEffect(() => {
    assessmentApi()
      .then((response) => {
        setAssessments(response);

        if (!selectedAssessment) {
          const assess = response.find(
            (o) => o.stayStart === getItem('selectedAssessmentDate')
          )
            ? getItem('selectedAssessmentDate')
            : undefined;
          setSelectedAssessment(assess ? assess : response[0].stayStart);
        }
      })
      .catch((err) => console.error(err));
  }, []);
  const handleCollapsible = (index) => {
    const collapse: any = [];
    Object.keys(collapse).forEach((key) => {
      collapse[key] = false;
    });
    if (!toggle[index]) {
      collapse[index] = true;
    } else {
      if (toggle[index] == true) {
        collapse[index] = false;
      } else {
        collapse[index] = true;
      }
    }
    setToggle(collapse);
  };

  const handleTabs = (index) => {
    const collapse: any = [];
    Object.keys(collapse).forEach((key) => {
      collapse[key] = false;
    });
    if (!collapse[index]) {
      collapse[index] = true;
    } else {
      if (collapse[index] == true) {
        collapse[index] = false;
      } else {
        collapse[index] = true;
      }
    }
    settoggleTab(collapse);
  };

  const handleSubTabs = (index) => {
    const collapse: any = [];
    Object.keys(collapse).forEach((key) => {
      collapse[key] = false;
    });
    if (!collapse[index]) {
      collapse[index] = true;
    } else {
      if (collapse[index] == true) {
        collapse[index] = false;
      } else {
        collapse[index] = true;
      }
    }
    settoggleSubTab(collapse);
  };
  const departmentHeaderText = getDepartmentText(
    subCat.find((o) => o.id === selectedCategory)
  );
  return (
    <AssessmentStandarContainer>
      <HeaderContainer>
        <AppHeader />
        <HotelAssessmentSelection
          assessments={assessments}
          setAssessments={setAssessments}
          selectedHotel={selectedHotel}
          setSelectedHotel={setSelectedHotel}
          selectedClient={selectedClient}
          setSelectedClient={setSelectedClient}
          selectedAssessment={selectedAssessment}
          setSelectedAssessment={setSelectedAssessment}
          isSelectDate={true}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          selectedCompset={0}
          setSelectedCompset={() => { }}
          hasAssessment={hasAssessment}
          setHasAssessment={setHasAssessment}
        />
      </HeaderContainer>
      {!selectedAssessment || isLoading ? (
        <ContentArea>
          <div className="box-shadow d-block">
            <div className="m-10 mb-20">
              <Skeleton
                containerClassName="flex-1"
                height={230}
                borderRadius={5}
              />

              <div className="row-separater-skeleton mb-10">
                <Skeleton width={150} height={30} borderRadius={5} />
                <Skeleton width={50} height={25} borderRadius={5} />
              </div>
              <div className="row-separater-skeleton pl-15 pr-15 mb-10">
                <Skeleton width={150} height={50} borderRadius={5} />
                <Skeleton width={150} height={50} borderRadius={5} />
              </div>
              <div className="pl-15 pr-15">
                <Skeleton
                  containerClassName="flex-1"
                  height={300}
                  borderRadius={5}
                />
              </div>
            </div>
          </div>
        </ContentArea>
      ) : (
        <ContentArea>
          <Block className="stdcontainer">
            <div className="d-block clear-both">
              <StandardPerformaceSelector
                standard={standards}
                setStandard={setStandards}
                selectedHotel={selectedHotel}
                selectedClient={selectedClient}
                selectedAssessment={selectedAssessment}
                performanceClassification={performanceClassification}
                setPerformaceClassification={setPerformaceClassification}
                isSelf={false}
              />
            </div>
            <div>
              <div className="f-left mr-10 border-right-1">
                <div className="d-block text-center background-E1E1E1 mr-10 f-left w-50px p-5 border-radius-4">
                  <span className="f-17 fw-600 d-block">
                    {score.toFixed(1)}%
                  </span>
                  <span className="f-15 fw-400 d-block">Score</span>
                </div>
                <div className="d-block text-center background-E1E1E1 mr-10 f-left w-50px p-5 border-radius-4">
                  <span className="f-17 fw-600 d-block">
                    {std && std.stats[0].value}
                  </span>
                  <span className="f-15 fw-400 d-block">Points</span>
                </div>
              </div>
              <div>
                <div
                  className="background-58C3BB border-radius-4 d-block text-center f-left w-50px mr-10 p-5"
                  onClick={() => {
                    setShowMet({
                      met: !showMet.met,
                      notmet: false,
                      na: false,
                    });
                  }}
                >
                  <span className="f-17 fw-600 d-block">
                    {std && std.stats[1].countValue}
                  </span>
                  <span className="f-15 fw-400 d-block">Met</span>
                </div>
                <div
                  className="background-EF374E border-radius-4 d-block text-center f-left w-50px mr-10 p-5"
                  onClick={() =>
                    setShowMet({
                      met: false,
                      notmet: !showMet.notmet,
                      na: false,
                    })
                  }
                >
                  <span className="f-17 fw-600 d-block">
                    {std && std.stats[2].countValue}
                  </span>
                  <span className="f-15 fw-400 d-block">Not Met</span>
                </div>
                <div
                  className="d-block text-center background-E1E1E1 mr-9 f-left w-50px p-5 border-radius-4"
                  onClick={() =>
                    setShowMet({
                      met: false,
                      notmet: false,
                      na: !showMet.na,
                    })
                  }
                >
                  <span className="f-17 fw-600 d-block">
                    {std && std.stats[3].countValue}
                  </span>
                  <span className="f-15 fw-400 d-block">N/A</span>
                </div>
              </div>
            </div>

            <div className="tabs mt-20">
              <ul className="tabs-ul">
                {l.data.map((tab, index) => (
                  // tslint:disable-next-line:jsx-key
                  <li
                    onClick={() => {
                      handleTabs(index);
                      handleSubTabs(parseInt(`${index + 1}${0}`));
                      setSubCat(tab.subCategory);
                      setSelectedCategory(tab.subCategory[0].id);
                      setIndex(index + 1);
                      setScore(tab.subCategory[0].score);
                    }}
                    className={`${toggleTab[index] ? 'activeTab' : ''} f-15 lh-20`}
                  >
                    {tab.name}
                  </li>
                ))}
              </ul>
              <div className="tabContainer">
                {l.data.map((category, index) => (
                  // tslint:disable-next-line:jsx-key
                  <div
                    id={index}
                    className={`tabContent ${toggleTab[index] ? 'active' : ''}`}
                  >
                    <div className="subTabs">
                      <ul className="subTabs-ul">
                        {subCat &&
                          subCat.map((subCategory, index) => (
                            // tslint:disable-next-line:jsx-key
                            <li
                              onClick={() => {
                                handleSubTabs(`${Index}${index}`);
                                setSelectedCategory(subCategory.id);
                                setScore(subCategory.score);
                              }}
                              className={`${toggleSubTab[parseInt(`${Index}${index}`)] ? 'activeSubTab fw-400' : 'fw-600'}  f-10 lh-12`}
                            >
                              {subCategory.name} - Standards
                            </li>
                          ))}
                      </ul>
                      <div className="subTabContainer">
                        {category.subCategory.map((sub, i) => (
                          // tslint:disable-next-line:jsx-key
                          <div
                            className={`tabContent ${toggleSubTab[parseInt(`${index + 1}${i}`)]
                                ? 'active'
                                : ''
                              }`}
                          >
                            <div>
                              <div className="color-58C3BB mb-10 f-20 fw-600 lh-24">
                                {sub.name} - Standards
                              </div>
                              <span className="fw-400 f-12 lh-16 color-717171">
                                {departmentHeaderText}
                              </span>
                              <div className="stdIconContainer">
                                <div
                                  className="mr-22 f-left"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setEqData({
                                      ...sub.departmentEq,
                                      depCommentary: sub.departmentCommentary,
                                      subName: sub.name,
                                      time:
                                        sub.dateTimeFormat === 'date'
                                          ? sub.date
                                          : sub.dateTime,
                                    });
                                    sub.departmentEq || sub.departmentCommentary
                                      ? setOpen(true)
                                      : setOpen(false);
                                  }}
                                >
                                  <Icon
                                    kind={
                                      sub.departmentEq ||
                                        sub.departmentCommentary
                                        ? 'commentgreen'
                                        : 'commentgrey'
                                    }
                                    width={25}
                                    height={25}
                                    className="fill-58c3bb"
                                  />
                                </div>
                                {sub.audioAttachments &&
                                  sub.audioAttachments.length > 0 ? (
                                  <div
                                    className="mr-22 f-left"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setAudioOverlayOpened(true);
                                      setAudio(
                                        sub.audioAttachments.map((a) => a)
                                      );
                                    }}
                                  >
                                    <Icon
                                      kind="speakergreen"
                                      width={25}
                                      height={25}
                                      className="fill-979797"
                                    />
                                  </div>
                                ) : (
                                  <div className="mr-22 f-left">
                                    <Icon
                                      kind="speakergrey"
                                      width={20}
                                      height={20}
                                      className="fill-979797"
                                    />
                                  </div>
                                )}
                                <div
                                  className="mr-22 f-left"
                                  onClick={() => {
                                    setPressHoldData(sub);
                                    setOpenPressHold(true);
                                  }}
                                >
                                  <Icon
                                    kind="edit-diary"
                                    height={25}
                                    width={25}
                                    style={{ fill: '#979797' }}
                                  />
                                </div>
                                {/* {sub.imageAttachments && sub.imageAttachments.length > 0  ?<ImageOverlay
                                images={sub.imageAttachments.map(a => ({ source: a.url }))}
                                target={(
                                  <div className='f-left'> <Icon kind="imagegreen" width={25} height={25} className='fill-979797'></Icon></div>
                                )}
                            />: <div className='f-left'><Icon kind="imagegrey" width={25} height={25} ></Icon></div>} */}
                                {sub.imageAttachments &&
                                  sub.imageAttachments.length > 0 ? (
                                  <div
                                    className="f-left"
                                    onClick={() => {
                                      setImageData(sub.imageAttachments),
                                        setOpenImage(true);
                                    }}
                                  >
                                    {' '}
                                    <Icon
                                      kind="imagegreen"
                                      width={25}
                                      height={25}
                                      className="fill-979797"
                                    />
                                  </div>
                                ) : (
                                  <div className="f-left" onClick={() => { }}>
                                    <Icon
                                      kind="imagegrey"
                                      width={25}
                                      height={25}
                                    />
                                  </div>
                                )}

                                {/* <a onClick={(e) => {e.stopPropagation();setEqData({...sub.departmentEq, depCommentary: sub.departmentCommentary, subName: sub.name, time: sub.dateTimeFormat === 'date' ? sub.date : sub.dateTime}); sub.departmentEq || sub.departmentCommentary?setOpen(true):setOpen(false);}}>
                          <Icon kind={sub.departmentEq || sub.departmentCommentary? "commentgreen" :"commentgrey"} width={25} height={25} className='fill-58c3bb'></Icon></a>                          */}
                                {/* <Icon
                            kind="happy"
                            height={25}
                            width={25}
                            style={{ fill: "#919191" }}
                          /> */}
                                {/* <Icon
                            kind={sub.audioAttachments ?"speakergreen": "speakergrey"}
                            height={25}
                            width={25}
                            style={{ fill: "#979797" }}
                          /> */}

                                {/* <a {...bind(sub)} >
                          <Icon
                            kind="edit-diary"
                            height={25}
                            width={25}
                            style={{fill: "#979797"}}
                          />
                          </a> */}

                                {/* <Icon
                            kind={sub.imageAttachments ?"imagegreen": "imagegrey"}
                            height={30}
                            width={30}
                            style={{ fill: "#979797" }}
                          />
                           */}
                              </div>
                              <hr className="border-top-d1dbec-1" />
                              {showMet && std ? (
                                std.items.map((itm, indx) => {
                                  if (
                                    showMet.met !== false ||
                                    showMet.notmet !== false ||
                                    showMet.na !== false
                                  ) {
                                    if (showMet.met === true) {
                                      if (itm.missedCount > 0) {
                                        return <></>;
                                      }
                                      if (itm.naCount > 0) {
                                        return <></>;
                                      }
                                    }
                                    if (showMet.notmet === true) {
                                      if (itm.hitCount > 0) {
                                        return <></>;
                                      }
                                      if (itm.naCount > 0) {
                                        return <></>;
                                      }
                                    }
                                    if (showMet.na === true) {
                                      if (itm.hitCount > 0) {
                                        return <></>;
                                      }
                                      if (itm.missedCount > 0) {
                                        return <></>;
                                      }
                                    }
                                  }
                                  if (itm.type === 'standard') {
                                    return (
                                      <div className="pb-20 pt-10 border-bottom-grey-1">
                                        <div className="tagsContainer pb-5 fw-600 f-10 lh-12 color-717171">
                                          <Tags
                                            data={[
                                              {
                                                label:
                                                  translatePerformanceClassificationLabel(
                                                    itm.performanceClassification
                                                  ),
                                              },
                                            ]}
                                          />
                                        </div>
                                        <div
                                          className="iconsContainerStd"
                                          onClick={() =>
                                            handleCollapsible(indx)
                                          }
                                        >
                                          {itm.comments && itm.comments[0] ? (
                                            <Icon
                                              kind="commentgreen"
                                              height={20}
                                              width={20}
                                              style={{ fill: '#58C3BB' }}
                                            />
                                          ) : (
                                            <Icon
                                              kind="commentgrey"
                                              height={20}
                                              width={20}
                                              style={{ fill: '#919191' }}
                                            />
                                          )}
                                          {itm.missedCount > 0 && (
                                            <Icon
                                              kind="thumbs-down"
                                              height={20}
                                              width={20}
                                              style={{ fill: 'red' }}
                                            />
                                          )}
                                          {itm.hitCount > 0 && (
                                            <Icon
                                              kind="thumbs-up"
                                              height={20}
                                              width={20}
                                              style={{
                                                fill: '#58C3BB',
                                                height: '20px !important',
                                                width: '20px !important',
                                              }}
                                            />
                                          )}
                                          {itm.naCount > 0 && (
                                            <Icon
                                              kind="na"
                                              height={20}
                                              width={20}
                                              style={{
                                                fill: '#FFF',
                                                height: '20px !important',
                                                width: '20px !important',
                                              }}
                                            />
                                          )}
                                        </div>
                                        <div
                                          className="f-15 mb-10 clear-both"
                                          onClick={() =>
                                            handleCollapsible(indx)
                                          }
                                        >
                                          <a
                                            {...bind({
                                              ...sub,
                                              standard: [
                                                {
                                                  standardId: itm.standardId,
                                                  selected: true,
                                                },
                                              ],
                                            })}
                                          >
                                            <div className="f-left w-95 fw-400 f-15 lh-20 color-1F1F1F">
                                              {`${itm.nr}. ${itm.label}`}
                                            </div>
                                          </a>
                                          <div className="f-right text-right w-5 mt-10">
                                            {/* {if(itm.comments.lenght > 0 && itm.comments[0].length > 0) {<Icon kind={toggle[indx] ? "arrow-up" : "arrow-down"} height={15} width={15} />}} */}
                                            {itm.comments && itm.comments[0] ? (
                                              <Icon
                                                kind={
                                                  toggle[indx]
                                                    ? 'arrow-up'
                                                    : 'arrow-down'
                                                }
                                                height={15}
                                                width={15}
                                              />
                                            ) : (
                                              <Icon
                                                kind="arrow-down"
                                                height={1}
                                                width={1}
                                              />
                                            )}
                                          </div>
                                        </div>
                                        <div className="clear-both" />
                                        <Collapse isOpened={toggle[indx]}>
                                          <div className="f-13 background-f1f1f1 p-5 fw-400 f-12 lh-16 border-radius-5">
                                            {itm.comments &&
                                              itm.comments[0] &&
                                              typeof itm.comments[0] === 'string'
                                              ? itm.comments[0].replace(
                                                ANNONYMOUS_NAME,
                                                'employee'
                                              )
                                              : ''}
                                          </div>
                                        </Collapse>
                                      </div>
                                    );
                                  } else {
                                    return <></>;
                                  }
                                })
                              ) : (
                                <LoadingContent />
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {pressAndHoldMenu(
              pressHoldData,
              setOpenPressHold,
              openPressAndHold,
              selectedAssessment,
              tempData,
              l,
              navigate
            )}
            {Portal(
              eqData,
              open,
              setOpen,
              showCom,
              setShowCom,
              showEq,
              setShowEq
            )}
            {bottomSheet(
              imageData,
              openImage,
              setOpenImage,
              selectedUrl,
              setSelectedUrl,
              notes,
              setNotes
            )}
            {audio.length > 0 && (
              <OverlayAudio
                isOpen={audioOverlayOpened}
                setOpen={setAudioOverlayOpened}
                audioUrls={audio}
                setAudio={setAudio}
              />
            )}
          </Block>
        </ContentArea>
      )}
    </AssessmentStandarContainer>
  );
};

export default AssessmentStandard;
